import { useState } from "react";

import styled from "styled-components";

import useLoading from "components/atoms/loading/useLoading";

import { ModalContainer, ModalDescText } from "components/page/modal/styled";
import AbstractModal from "components/page/modal/AbstractModal";

const BibTeXContainer = styled.div`
    margin: 24px 0 0 0;
    padding: 6px;
    width: 100%;
    height: 240px;
    max-height: 320px;
    background-color: var(--color-CodeBack);
    border: solid 2px var(--color-Black);
    border-radius: 4px;
`;

const Textarea = styled.textarea`
    width: 100%;
    height: auto;
    min-height: 100%;
    line-height: 1.8;
    font-size: 13px;
    font-weight: 400;
    color: var(--color-White);
    background-color: transparent;
    border: transparent;
    outline: none;
    resize: none;

    &::placeholder {
        color: var(--color-DisabledText);
    }

    &::-webkit-scrollbar {
        width: 6px;
        display: initial;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--color-Black);
    }
`;

function ReferenceAddBibtexModal(props) {
    const { setLoading } = useLoading();
    const [bibtex, setBibtex] = useState("");

    const addReferenceWithBibtex = () => {
        setLoading(true);
        props.mutation.mutate(
            {
                addWithBibtex: true,
                body: {
                    bib: bibtex,
                },
            },
            {
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="BibTeX로 참고문헌 추가"
            width={560}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "추가",
                leftOnClick: props.exitModal,
                rightOnClick: addReferenceWithBibtex,
                disabled: !bibtex,
            }}
        >
            <ModalContainer>
                <ModalDescText>
                    BibTeX 양식에 맞춰 정보를 입력해주세요.
                    <br />
                    입력완료 후 추가버튼을 선택하면 참고문헌이 추가됩니다.
                </ModalDescText>
                <BibTeXContainer>
                    <Textarea
                        autoFocus
                        value={bibtex}
                        onChange={(e) => setBibtex(e.target.value)}
                        placeholder='@misc{citekey,&#13;&#10; title = "The title of the miscellaneous entry",&#13;&#10; author = "A. Author",&#13;&#10; howpublished = "How it was published",&#13;&#10; month = "Month",&#13;&#10; year = "Year",&#13;&#10; note = "An optional note",&#13;&#10;}'
                    />
                </BibTeXContainer>
            </ModalContainer>
        </AbstractModal>
    );
}

export default ReferenceAddBibtexModal;
